import { programPageData } from './program-page.model';
export var programPageInfoJson = programPageData // ProgramPage靜態設定檔
.slice();
